import {
  SET_SIDER_WIDTH,
  RESET_SIDER_WIDTH,
} from './actionTypes';

const initialState = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

const siders = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIDER_WIDTH:
      return {
        ...state,
        [action.payload.position]: action.payload.newWidth,
      };

    case RESET_SIDER_WIDTH:
      return {
        ...state,
        [action.payload.position]: initialState[action.payload.position],
      };

    default:
      return state;
  }
};

export default siders;



// WEBPACK FOOTER //
// ./src/components/page/EnhancedSider/flow/reducer.js